import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useI18n } from "@/i18n/I18nContext";
import { getPrivacy } from "@/i18n/privacyContent";

export default function Privacy() {
  const { lang } = useI18n();
  const c = getPrivacy(lang);

  return (
    <div className="grain relative bg-theatre-ink min-h-screen" data-testid="privacy-page">
      <Navbar />
      <main className="pt-32 pb-24 px-6 lg:px-10">
        <div className="max-w-3xl mx-auto">
          <Link to="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-neutral-400 hover:text-theatre-gold transition-colors duration-200 mb-10">
            <ArrowLeft size={14} /> Viva Artist
          </Link>

          <h1 className="font-serif text-4xl md:text-5xl text-white">{c.title}</h1>
          <p className="mt-3 font-mono text-xs tracking-[0.2em] uppercase text-theatre-gold">{c.updated}</p>
          <div className="mt-6 h-px w-32 gold-hr" />
          <p className="mt-8 text-neutral-300 leading-relaxed">{c.intro}</p>

          <div className="mt-12 space-y-8">
            {c.sections.map((s, i) => (
              <div key={i} data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-xl text-theatre-gold">{s.h}</h2>
                <p className="mt-3 text-neutral-300 leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 pt-10 border-t border-white/10">
            <h2 className="font-serif text-3xl text-white">{c.legalTitle}</h2>
            <div className="mt-8 space-y-8">
              {c.legal.map((s, i) => (
                <div key={i} data-testid={`legal-section-${i}`}>
                  <h3 className="font-serif text-lg text-theatre-gold">{s.h}</h3>
                  <p className="mt-2 text-neutral-300 leading-relaxed">{s.p}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
